import { END_POINTS } from '../helpers';
import { CommonBody, FaqRes } from '../types/General';
import { User } from '../types/User';
import emptySplitApi from '../utils/rtk';

type CommonResponseType = {
  statusCode: number;
  data?: User;
  message: string;
};

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};

type GetCmsResponse = {
  _id: string;
  email: string;
  phone: string;
  terms: string;
  privacyPolicy: string;
  aboutUs: string;
  dialCode: string;
};

export type GetSettingResponse = {
  inspectionFee: number;
  postingFee: number;
  _id: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  id: string;
};

type GetFaqResponse = {
  count: number;
  faqs: FaqRes[];
};

export const faqApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    // getVehicleTypes: builder.query<
    //   CommonResponse & { data: GetCmsTypeResponse },
    //   {
    //     page: number;
    //     limit: number;
    //     search: string;
    //   }
    // >({
    //   query: ({ page, limit, search }) => ({
    //     url: `${END_POINTS.getVehicleTypes}?page=${page}&limit=${limit}${
    //       search?.length ? `&search=${search}` : ""
    //     }`,
    //     method: "GET",
    //   }),
    // }),

    // deleteVehicleType: builder.query<CommonResponse, { id: string }>({
    //   query: ({ id }) => ({
    //     url: `${END_POINTS.deleteVehicleType}/${id}`,
    //     method: "DELETE",
    //   }),
    // }),
    // getVehicleTypeById: builder.query<
    //   CommonResponse & { data: VehicleType },
    //   { id: string }
    // >({
    //   query: ({ id }) => ({
    //     url: `${END_POINTS.getVehicleById}/${id}`,
    //     method: "GET",
    //   }),
    // }),

    // addVehicle: builder.mutation<
    //   CommonResponseType & { data: VehicleType },
    //   { body: CommonBody }
    // >({
    //   query: ({ body }) => ({
    //     url: `${END_POINTS.vehicleType}`,
    //     method: "POST",
    //     body,
    //   }),
    // }),
    // updateVehicleType: builder.mutation<
    //   CommonResponseType & { data: VehicleType },
    //   { body: CommonBody; id: string }
    // >({
    //   query: ({ body, id }) => ({
    //     url: `${END_POINTS.updateVehicle}/${id}`,
    //     method: "PUT",
    //     body,
    //   }),
    // }),

    getCms: builder.query<CommonResponse & { data: GetCmsResponse }, {}>({
      query: () => ({
        url: END_POINTS.cms,
        method: 'GET',
      }),
    }),

    getSetting: builder.query<CommonResponseType & { data: GetSettingResponse }, {}>({
      query: () => ({
        url: END_POINTS.setting,
        method: 'GET',
      }),
    }),

    updateCms: builder.mutation<
      CommonResponseType & { data: GetCmsResponse },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.cms}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
    addSetting: builder.mutation<CommonResponseType & { data: any }, { body: CommonBody }>({
      query: ({ body }) => ({
        url: `${END_POINTS.setting}`,
        method: 'POST',
        body,
      }),
    }),

    getFaqs: builder.query<
      CommonResponse & { data: GetFaqResponse },
      {
        page: number;
        limit: number;
        search?: string;
      }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.faqList}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ''
        }`,
        method: 'GET',
      }),
    }),
    addFaq: builder.mutation<CommonResponseType & { data: FaqRes }, { body: CommonBody }>({
      query: ({ body }) => ({
        url: `${END_POINTS.faq}`,
        method: 'POST',
        body,
      }),
    }),
    updateFaq: builder.mutation<
      CommonResponseType & { data: FaqRes },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.faq}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
    deleteFaq: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.faq}/${id}`,
        method: 'DELETE',
      }),
    }),
    deleteNewsletter: builder.mutation<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.newsletter}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['EMAIL'],
    }),
    getNewsletter: builder.query<
      CommonResponse & { data: any },
      {
        page: number;
        limit: number;
        search?: string;
      }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.newsletter}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ''
        }`,
        method: 'GET',
      }),
      keepUnusedDataFor: 300,
      providesTags: ['EMAIL'],
    }),
  }),
});

export const {
  useLazyGetCmsQuery,
  useLazyGetSettingQuery,
  useAddSettingMutation,
  useUpdateCmsMutation,
  useLazyGetFaqsQuery,
  useAddFaqMutation,
  useUpdateFaqMutation,
  useLazyDeleteFaqQuery,
  useDeleteNewsletterMutation,
  useGetNewsletterQuery,
} = faqApi;
